import { render } from "./formtransfer.vue?vue&type=template&id=327665dc&scoped=true"
import script from "./formtransfer.js?vue&type=script&lang=js"
export * from "./formtransfer.js?vue&type=script&lang=js"

import "./formtransfer.vue?vue&type=style&index=0&id=327665dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327665dc"]])

export default __exports__